"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;flex-direction:column;width:100%;background-color:", theme.color.monochrome.light, ";border:1px solid ", theme.color.monochrome.medium, ";padding:", theme.spacing['10'], " ", theme.spacing['12'], ";&>*:not(:last-child){margin-bottom:", theme.spacing['5'], ";}button,a{border-radius:", theme.spacing['4'], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var styles = {
  base: base
};
exports.styles = styles;
//# sourceMappingURL=ModalBtns.styles.js.map